export default __webpack_public_path__ + "static/essence-vanilla-25d7a37f6c17ed45cbd307f0e33fd66e.svg";